import { connect } from 'react-redux';
import TagShowView from './tag_show_view';

const TagShowContainer = connect()(TagShowView);

export default TagShowContainer;
